module.exports = __webpack_public_path__ + "img/act2_img_biaoti@2x.5250335a.png";